import { render, staticRenderFns } from "./ReviewsAnalyst.vue?vue&type=template&id=2c5f9f7c&scoped=true&"
import script from "./ReviewsAnalyst.vue?vue&type=script&lang=js&"
export * from "./ReviewsAnalyst.vue?vue&type=script&lang=js&"
import style0 from "./ReviewsAnalyst.vue?vue&type=style&index=0&id=2c5f9f7c&lang=scss&scoped=true&"
import style1 from "./ReviewsAnalyst.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5f9f7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VRow})
